// extracted by mini-css-extract-plugin
export default {"miner":"Game_miner__34R0-","container":"Game_container__g92Wm","footer":"Game_footer__N6kYQ"};